import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  Validator,
} from "common";
import I18n from "i18n-js";
import {
  getLocationService,
  LocationFormItem,
  LocationOptions,
} from "./locationApi";

export interface UseLocationFormProps extends GridModalFormProps {}

export default function useLocationForm({
  id,
  afterSave,
}: UseLocationFormProps) {
  const service = getLocationService();

  const form = useForm<LocationFormItem, LocationOptions>({
    id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "Location",
    rules: {
      name: Validator.rule.any().required(),
      county: Validator.rule.any().required(),
      address: Validator.rule.any().required(),
      zip: Validator.rule.any().required(),
    },
    afterSave,
    afterLoad: _newItem => {},
    onValidationFailed: () => {
      globalMessageHandler.error(I18n.t("App.formHasErrors"));
    },
    ...service,
  });

  return form;
}
